import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ListGroup, ListGroupItem, Input } from 'reactstrap';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './UnassignedObis.css';
import {
  getUnassignedObis,
  setUnassignedMacFilter,
  clearUnassignedObis,
} from '../actions/EpikBoxes';

const basePaginateOptions = {
  page: 1,
  limit: 20,
};

class UnassignedObis extends Component {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken') || null;
    this.state = {
      paginateOptions: basePaginateOptions,
    };
    this.onObiFilterChange = this.onObiFilterChange.bind(this);
  }

  loadFunction = page => {
    const { paginateOptions } = this.state;
    const paginateParams = {
      ...paginateOptions,
      ...{ page },
    };
    this.props.fetchUnassignedObis(this.token, paginateParams, this.props.unassignedObiFilter);
  };

  onObiFilterChange(ev) {
    const { value } = ev.target;
    this.props.setUnassignedMacFilter(value);
  }

  componentDidMount() {
    this.loadFunction(1);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.unassignedObiFilter !== this.props.unassignedObiFilter) {
      this.props.clearUnassigned();
      this.loadFunction(1);
    }
  }

  render() {
    const { unassignedObis, onAssignObi } = this.props;
    const uniqueUnassignedObis = unassignedObis?.docs.filter(
      (obj, index, self) => index === self.findIndex(t => t._id === obj._id),
    );
    return (
      <>
        <Input
          className="unassignedSearch"
          value={this.props.unassignedObiFilter}
          onChange={this.onObiFilterChange}
          placeholder="Search MAC Address..."
        />

        <ListGroup className="unassignedList">
          <InfiniteScroll
            pageStart={1}
            loadMore={this.loadFunction}
            hasMore={this.props.unassignedObis.hasNextPage}
            useWindow={false}
          >
            {uniqueUnassignedObis?.map(obi => (
              <div
                data-obi-id={obi._id}
                onClick={() => {
                  onAssignObi(obi);
                }}
                className="unassignedObi"
                key={obi._id}
              >
                <ListGroupItem className={obi.assignedTo ? 'obiListItemAssigned' : 'obiListItem'}>
                  {obi.macAddress}
                </ListGroupItem>
              </div>
            ))}
            {uniqueUnassignedObis?.length === 0 && (
              <div>
                {this.props.unassignedEPIsListLoading ? (
                  <div style={{ textAlign: 'center' }}>
                    <FontAwesomeIcon fixedWidth spin className="port-info-icon" icon="spinner" />
                    <span> Loading...</span>
                  </div>
                ) : (
                  <div>No Unassigned MAC Adresses Found</div>
                )}
              </div>
            )}
          </InfiniteScroll>
        </ListGroup>
      </>
    );
  }
}

const mapStateToProps = state => ({
  unassignedObis: state.AppState.obis.unassignedObis,
  unassignedObiFilter: state.UIState.obis.unassignedFilter,
  unassignedEPIsListLoading: state.UIState.obis.unassignedEPIsListLoading,
});

const mapDispatchToProps = dispatch => ({
  fetchUnassignedObis: (token, paginateOptions, searchString) =>
    dispatch(getUnassignedObis(token, paginateOptions, searchString)),
  setUnassignedMacFilter: searchString => dispatch(setUnassignedMacFilter(searchString)),
  clearUnassigned: () => dispatch(clearUnassignedObis()),
});

UnassignedObis.propTypes = {
  unassignedObis: PropTypes.object,
  onAssignObi: PropTypes.func,
  fetchUnassignedObis: PropTypes.func,
  clearUnassigned: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UnassignedObis);
